/* eslint-disable no-console */
import {IPaginatedResult, IPaginatedSearch} from '../incase-domain/search';
import {httpPost} from './http.service';
import {ConnectionRequestStatus, ConnectionRequestType, IConnection, IConnectionRequest} from '../incase-domain/connection';

export const sendConnectionRequest = (recipientId: string): Promise<IConnectionRequest> => {
    return httpPost(`editor/connections/sendRequest`, {recipientId}).catch((error) => {
        console.log(error);
        return error.response.data;
    });
};

export const updateConnectionRequest = (connectionRequestId: string, status: ConnectionRequestStatus): Promise<IConnection> => {
    return httpPost(`editor/connections/updateRequest`, {connectionRequestId, status});
};

export const fetchConnectionRequests = (
    type: ConnectionRequestType,
    paginatedSearch: IPaginatedSearch
): Promise<IPaginatedResult<IConnectionRequest>> => {
    const {pageNumber, pageSize, ...searchObj} = paginatedSearch;
    return httpPost(`editor/connections/requests/${type}/${pageNumber}/${pageSize}/`, searchObj).catch((error) => {
        console.log(error);
    });
};

export const fetchConnections = (paginatedSearch: IPaginatedSearch): Promise<IPaginatedResult<IConnection>> => {
    const {pageNumber, pageSize, searchString} = paginatedSearch;
    return httpPost(`editor/connections/${pageNumber}/${pageSize}/`, {
        searchObj: {searchString, pageNumber, pageSize: pageSize || 12},
    }).catch((error) => {
        console.log(error);
    });
};

export const removeConnection = (connectionId: string): Promise<IConnection> => {
    return httpPost(`editor/connections/remove`, {connectionId}).catch((error) => {
        console.log(error);
    });
};
